// src/services/securityService.js
/**
 * Service to handle security-related functionality
 */
const securityService = {
  /**
   * Check if the current connection is secure (HTTPS)
   * @returns {boolean} True if connection is secure
   */
  isHttps: () => {
    return window.location.protocol === 'https:';
  },
  
  /**
   * Redirect to HTTPS if currently on HTTP
   * @param {boolean} force - Force redirect even in development
   * @returns {boolean} True if redirected
   */
  enforceHttps: (force = false) => {
    // Skip redirect for localhost/development unless forced
    if (!force && (
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1' ||
      process.env.NODE_ENV === 'development'
    )) {
      return false;
    }
    
    // Redirect to HTTPS if currently on HTTP
    if (window.location.protocol === 'http:') {
      window.location.href = window.location.href.replace('http:', 'https:');
      return true;
    }
    
    return false;
  },
  
  /**
   * Check if URL is using HTTPS
   * @param {string} url - URL to check
   * @returns {boolean} True if URL is HTTPS
   */
  isUrlSecure: (url) => {
    try {
      return new URL(url).protocol === 'https:';
    } catch (error) {
      console.warn('Invalid URL:', error);
      return false;
    }
  },
  
  /**
   * Ensure a URL uses HTTPS
   * @param {string} url - URL to secure
   * @returns {string} HTTPS URL
   */
  secureUrl: (url) => {
    try {
      const urlObj = new URL(url);
      if (urlObj.protocol === 'http:') {
        urlObj.protocol = 'https:';
      }
      return urlObj.toString();
    } catch (error) {
      console.warn('Invalid URL:', error);
      return url;
    }
  }
};

export default securityService;